import { cva, type VariantProps } from "class-variance-authority";

// Extended button variants with hero, premium, and glass options
export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary/90 backdrop-blur-sm text-primary-foreground hover:bg-primary shadow-lg hover:shadow-xl hover:scale-[1.02]",
        destructive:
          "bg-secondary/90 backdrop-blur-sm text-secondary-foreground hover:bg-secondary shadow-lg hover:shadow-xl hover:scale-[1.02]",
        outline:
          "border-2 border-primary/50 bg-background/60 backdrop-blur-sm text-primary hover:bg-primary hover:text-primary-foreground",
        secondary:
          "bg-secondary/80 backdrop-blur-sm text-secondary-foreground hover:bg-secondary shadow-lg hover:shadow-xl",
        ghost: "hover:bg-muted/60 backdrop-blur-sm hover:text-foreground",
        link: "text-primary underline-offset-4 hover:underline font-semibold",
        hero: "bg-primary/90 backdrop-blur-md text-primary-foreground shadow-xl hover:shadow-2xl hover:scale-[1.03] hover:bg-primary transition-all",
        premium: "bg-accent/90 backdrop-blur-sm text-accent-foreground shadow-xl hover:shadow-2xl hover:scale-[1.02] hover:bg-accent",
        glass: "bg-card/40 backdrop-blur-xl border border-border/40 text-foreground shadow-lg hover:shadow-xl hover:bg-card/60 hover:scale-[1.02]",
        "glass-primary": "bg-primary/20 backdrop-blur-xl border border-primary/30 text-primary shadow-lg hover:shadow-xl hover:bg-primary/30 hover:scale-[1.02]",
        blue: "bg-blue/90 backdrop-blur-sm text-white shadow-lg hover:shadow-xl hover:scale-[1.02] hover:bg-blue",
        red: "bg-red/90 backdrop-blur-sm text-white shadow-lg hover:shadow-xl hover:scale-[1.02] hover:bg-red",
        yellow: "bg-yellow/90 backdrop-blur-sm text-accent-foreground shadow-lg hover:shadow-xl hover:scale-[1.02] hover:bg-yellow",
      },
      size: {
        default: "h-11 px-5 py-2.5",
        sm: "h-9 rounded-lg px-4",
        lg: "h-12 rounded-xl px-8",
        xl: "h-14 rounded-2xl px-10 text-base",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
